import { render, staticRenderFns } from "./dashcard.vue?vue&type=template&id=14b06f14&"
import script from "./dashcard.vue?vue&type=script&lang=js&"
export * from "./dashcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports